import {PlaceApi} from "../../../services/Api/types";

export const getSortedPlacesByDistance = (places: PlaceApi[]) => {
    return [...places].sort((a, b) => {
        if (a.distance === undefined) return 1;
        if (b.distance === undefined) return -1;
        return a.distance - b.distance;
    });
};

export const calcPlaceDistance = (place: PlaceApi) => {
    if (!place.distance) return undefined;

    return Math.round((place.distance + Number.EPSILON) * 100) / 100
}